import { toast } from 'react-toastify';
import React from 'react';
import {
  Button, Col, FormGroup, Label, Input, Row, Modal, ModalBody, ModalHeader, ModalFooter
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import CampaignScheduleFields, { sendByDate, adjustExpiredLaunch, campaignTimeZone } from '../Campaign/CampaignScheduleFields';
import { DeliverySettingsPanel } from '../DeliverySettings/DeliverySettings';
import CampaignLinkDomainSelect from '../DeliverySettings/CampaignLinkDomainSelect';
import RecipientDomainGate from '../DeliverySettings/RecipientDomainGate';

export class SimulationsLaunchScreenForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      campaign: {
        url: '',
        link_domain_id: '',
        launch_date: moment().add(10, "minutes")
      },
      errors: {},
      linkReady: false,
      recipientsReady: false,
      domainRevision: 0
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.launchSimulation = this.launchSimulation.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.parseDate = this.parseDate.bind(this);
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.type === 'checkbox'
      ? event.target.checked : event.target.value;
    this.setState(updater => ({
      campaign: {
        ...updater.campaign,
        [key]: value
      }
    }));
  }

  handleLinkDomainChange = domain => this.setState(current => ({ linkReady: !!domain,
    campaign: { ...current.campaign, url: domain?.url || '', link_domain_id: domain?.id || '' },
    errors: { ...current.errors, url: '' } }));
  handleRecipientsReady = ready => this.setState({ recipientsReady: ready });
  closeDelivery = () => this.setState(current => ({ deliveryOpen: false, domainRevision: current.domainRevision + 1 }));

  handleCheckbox(event) {
    this.setState({
      configure_spam_filter: event.target.checked
    })
  }

  handleValidation() {
    var fields = this.state.campaign;
    var errors = {};
    var formIsValid = true;

    //Reset the errors
    this.setState({ errors: {} });

    //Name cannot be empty
    if (!fields["name"]) {
      formIsValid = false;
      errors["name"] = "Cannot be empty";
    }

    if (!this.state.linkReady || !fields["url"]) {
      formIsValid = false;
      errors["url"] = this.props.t('campaign_link_domains.required');
    }

    if (!fields["launch_date"]) {
      formIsValid = false;
      errors["launch_date"] = "Launch date cannot be empty";
    }

    if (!moment.isMoment(fields["launch_date"]) || !fields["launch_date"].isValid()) {
      formIsValid = false;
      errors["launch_date"] = "Launch date is Invalid";
    }

    if (!this.props.smtpProfile?.id) {
      formIsValid = false;
      errors["smtp"] = "SMTP config can not be empty";
    }
    if (!this.state.recipientsReady) { formIsValid = false; errors.recipients = this.props.t('authenticated_domains.policy_error'); }

    if (!this.state.configure_spam_filter) {
      formIsValid = false;
      errors["spam_filter"] = "Please check it before launching the simulation";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  handleDateChange(selectedDate, key) {
    this.setState(updater => ({
      campaign: {
        ...updater.campaign,
        [key]: selectedDate
      }
    }));
  }

  parseDate(date) {
    if (date && (moment.isMoment(date) || moment.isDate(date))) {
      return new Date(date.valueOf()).toISOString();
    }
    return date; // not able to format
  }

  launchSimulation() {
    if (this.props.launching || !this.props.smtpProfile?.id) return;
    if (this.handleValidation()) {
      const campaign = { ... this.state.campaign };
      const schedule = adjustExpiredLaunch(campaign.launch_date);
      campaign.launch_date = schedule.launchDate;
      if (schedule.adjusted) {
        this.setState(current => ({ campaign: { ...current.campaign, launch_date: schedule.launchDate } }));
        toast.info(this.props.t('simulation_wizard.schedule_adjusted', { date: schedule.launchDate.format('L LTS'), zone: campaignTimeZone(schedule.launchDate) }));
      }
      // format date only on launching
      campaign.send_by_date = this.parseDate(sendByDate(campaign.launch_date, (this.props.recipients || []).length));
      campaign.launch_date = this.parseDate(campaign.launch_date);
      this.props.onLaunch(campaign);
    }
  }

  render() {
    return (
      <><fieldset className="border-0 p-0 m-0" disabled={this.props.launching || !this.props.smtpProfile?.id}>
        <FormGroup>
          <Label for="name">{this.props.t('simulation_wizard.campaign_name')}</Label>
          <Input type="text" name="name" id="name" value={this.state.campaign.name || ''} onChange={this.handleChange} />
          <span style={{ color: "red" }}>{this.state.errors["name"]}</span>
        </FormGroup>
        <CampaignLinkDomainSelect domainId={this.state.campaign.link_domain_id} value={this.state.campaign.url}
          onChange={this.handleLinkDomainChange} onOpenSettings={() => this.setState({ deliveryOpen: true })}
          error={this.state.errors.url} t={this.props.t} />
        <RecipientDomainGate recipients={this.props.recipients} revision={this.state.domainRevision} onReady={this.handleRecipientsReady}
          onOpenSettings={() => this.setState({ deliveryOpen: true })} t={this.props.t} />
        <CampaignScheduleFields launchDate={this.state.campaign.launch_date} recipientCount={(this.props.recipients || []).length}
          error={this.state.errors["launch_date"]} onLaunchChange={data => this.handleDateChange(data, "launch_date")} t={this.props.t} />
        <FormGroup check className="mb-3">
          <Label check>
            <Input type="checkbox" checked={!!this.state.configure_spam_filter} onChange={this.handleCheckbox} />{' '}
            {this.props.t('delivery_settings.confirm_ready')}
          </Label>{' '}
          <Button color="link" className="p-0" onClick={() => this.setState({ deliveryOpen: true })}>{this.props.t('delivery_settings.view_settings')}</Button><br />
          <span style={{ color: "red" }}>{this.state.errors["spam_filter"]}</span>
        </FormGroup>
        <Row>
          <Col md={{ size: 3, offset: 9 }} >
            <FormGroup>
              <Button className="mb-2 mr-2 btn-icon btn-shadow" size="lg" color="success"
                disabled={this.props.launching || !this.props.smtpProfile?.id || !this.state.linkReady || !this.state.recipientsReady} onClick={() => { this.launchSimulation() }} style={{ "width": "160px" }}>
                {this.props.t(this.props.launching ? 'simulation_wizard.launching' : 'simulation_wizard.launch_action')}
              </Button>
            </FormGroup>
          </Col>
        </Row>
      </fieldset>
      {this.state.deliveryOpen && <Modal isOpen toggle={this.closeDelivery} size="xl" scrollable className="delivery-settings-dialog">
        <ModalHeader toggle={this.closeDelivery}>{this.props.t('delivery_settings.title')}</ModalHeader>
        <ModalBody><DeliverySettingsPanel t={this.props.t} /></ModalBody>
        <ModalFooter><Button color="link" onClick={this.closeDelivery}>{this.props.t('template_gallery.cancel')}</Button></ModalFooter>
      </Modal>}</>
    )
  }
}
export default withTranslation()(SimulationsLaunchScreenForm)
